import { render, staticRenderFns } from "./tagMag.vue?vue&type=template&id=358ee9f8&scoped=true&"
import script from "./tagMag.vue?vue&type=script&lang=js&"
export * from "./tagMag.vue?vue&type=script&lang=js&"
import style0 from "./tagMag.vue?vue&type=style&index=0&id=358ee9f8&lang=less&scoped=true&"
import style1 from "./tagMag.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358ee9f8",
  null
  
)

export default component.exports